// extracted by mini-css-extract-plugin
module.exports = {"c1aawmsq":"c1aawmsq","saag2jw":"saag2jw","line":"line"};